import React from 'react';
import { connect } from 'react-redux'
import Input from "../dig-components/input";
import { generateLinkQueryString } from '../../services/urlGeneratorService';
import { StyledButton } from "./StyledApplyChangesPane";
import { Flex } from '@m/alchemy-ui/Flex';

export const ApplyChangesPane  = (props) => {
  const { formUuid, propertyType, propertyId, urlPrefix, versionToPresent, isShowToggle, isDraft, shownMode, relatedUuid, deviceType } = props.app;
  const { customParams, hostingElement } = props;
  
  const [linkWithParams, setLinkWithParams] = React.useState('');

  React.useEffect(() => {
    const newLink = generateLinkQueryString(formUuid, propertyType, propertyId,  customParams, urlPrefix, hostingElement, versionToPresent, isShowToggle, isDraft, shownMode, relatedUuid, deviceType);

    setLinkWithParams(newLink)
  }, [formUuid, propertyType, customParams, urlPrefix, hostingElement, versionToPresent, isShowToggle, isDraft, shownMode, relatedUuid, deviceType]);

  const applyChanges = () => {
    window.location.href = linkWithParams;
  };

  return (
    <div className="apply-changes-pane">
      <div className="dig-section-break" />
      <Input
        label="Link to share"
        type="text"
        value={linkWithParams} disabled="true"
      />
      <div className="dig-section-break" />
      <Flex direction="row" justifyContent="end">
        <StyledButton onClick={applyChanges}> Apply Changes</StyledButton>
      </Flex>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    hostingElement: state.hostingElement,
    customParams: state.customParams,
    app: state.app
  };
}
export default connect(mapStateToProps, {})(ApplyChangesPane);
